<template>
  <div class="aboutUs">
    <sectionTitle :titleObj="titleObj"></sectionTitle>
    <div class="content">
      <div class="menu">
        <div @click="changeTabs(item)" class="menu-item flex-center" :class="{'menu-item-select':menuSelectName==item.name}" v-for="item in menu" :key="item.name">{{item.name}}</div>
      </div>
      <div style="flex:1"  v-loading="loading">
        <!-- <div v-if="menuSelectName === '协会框架'" class="relation-graph-container">
          <relation-graph ref="relationGraph" :options="graphOptions" :on-node-click="onNodeClick"></relation-graph>
        </div> -->
        <div v-html="text" class="text">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import sectionTitle from '@/components/sectionTitle.vue';
import {queryForm} from '@/api/api.js';
// import RelationGraph from 'relation-graph';

export default {
  components:{
    sectionTitle,
    // RelationGraph
  },
  data(){
    return {
      menuSelectName:'协会介绍',
      loading:true,
      titleObj:{
        title:'关于我们',
        subtitle:'ABOUT US'
      },
      menu:[
        {
          name:'协会介绍'
        },
        {
          name:'协会框架'
        },
        {
          name:'协会章程'
        },
        {
          name:'部门介绍'
        },
        {
          name:'协会位置'
        },
        {
          name:'联系方式'
        },
      ],
      textData:{},
      text:'',
      graphOptions: {
        defaultNodeShape: 0,
        defaultNodeWidth: 60,
        defaultNodeHeight: 60,
        defaultNodeColor: '#ED9D26',
        defaultNodeFontColor: '#FFFFFF',
        defaultNodeBorderColor: '#FFFFFF',
        defaultNodeBorderWidth: 2,
        defaultLineShape: 1,
        defaultLineColor: '#999999',
        defaultLineWidth: 2,
        defaultLineMarkerWidth: 8,
        defaultLineMarkerHeight: 8,
        defaultLineMarkerDirection: 1,
        defaultLineMarkerColor: '#999999',
        defaultLineMarker: true,
        layout: {
          layoutName: 'tree',
          layoutClassName: 'seeks-layout-center',
          direction: 'h',
          centerOffset_x: 0,
          centerOffset_y: 0,
          levelDistance: 120,
          nodeDistance: 80
        },
        moveToCenterWhenResize: true,
        zoomToFitWhenResize: true,
        disableDragNode: false,
        disableZoom: false,
        disableDragCanvas: false
      }
    }
  },
  created(){
    this.getInfo()
  },
  methods:{
    changeTabs(data){
      if(data.name!='协会框架'){
        this.menuSelectName=data.name
        if(!(this.textData[this.menuSelectName])){
          this.getInfo()
        }else{
          this.text=this.textData[this.menuSelectName]
        }
      }else{
        this.menuSelectName=data.name
        this.text='暂无内容'
        // this.$message.warning(`功能待开放`)
        // this.$nextTick(() => {
        //   if(this.menuSelectName === '协会框架' && this.$refs.relationGraph) {
        //     this.$refs.relationGraph.setJsonData(this.getRelationData())
        //   }
        // })
      }
    },
    onNodeClick(node, event) {
      console.log('点击节点:', node)
    },
    getRelationData() {
      return {
        rootId: 'root',
        nodes: [
          { id: 'root', text: '攀枝花市东区社会工作协会' },
          { id: 'branch1', text: '会员代表大会' },
          { id: 'branch2', text: '理事会' },
          { id: 'branch3', text: '监事会' },
          { id: 'dept1', text: '秘书处' },
          { id: 'dept2', text: '会员部' },
          { id: 'dept3', text: '培训部' },
          { id: 'dept4', text: '项目部' },
          { id: 'dept5', text: '宣传部' },
          { id: 'dept6', text: '财务部' },
          { id: 'dept7', text: '办公室' }
        ],
        lines: [
          { from: 'root', to: 'branch1' },
          { from: 'root', to: 'branch2' },
          { from: 'root', to: 'branch3' },
          { from: 'branch1', to: 'dept1' },
          { from: 'branch2', to: 'dept2' },
          { from: 'branch2', to: 'dept3' },
          { from: 'branch2', to: 'dept4' },
          { from: 'branch2', to: 'dept5' },
          { from: 'branch2', to: 'dept6' },
          { from: 'branch2', to: 'dept7' }
        ]
      }
    },
    getInfo(){
      queryForm({
        "formKey": "AaEjkxQZ",
        "queryId": "276",
        "queryParams": {
          "select1766470965763label": this.menuSelectName
        },
        "size": 1,
        "current": 0
      }).then(res=>{
        if(res.data.code==200){
          this.textData[this.menuSelectName]=res.data.data.rows.length>0?res.data.data.rows[0].rich_text1766470992037:'暂无内容'
          this.text=this.textData[this.menuSelectName]
        }
        this.loading=false
      })
    }
  }
}
</script>

<style lang="less" scoped>
.aboutUs{
  padding:0 10%;
  padding-bottom: 109px;
}
.content{
  gap:64px;
  display: flex;
  .menu{
    display: flex;
    flex-direction: column;
    gap:8px;
    .menu-item{
      width: 257px;
      height: 64px;
      background: #f3f1ef;
      cursor: pointer;
      font-size: 20px;
      color:#333333;
    }
    .menu-item-select{
      background: #ed9d26;
      color:#FFFFFF;
    }
  }
  .title{
    font-size: 36px;
    color: #333333;
    font-weight: bold;
    text-align: center;
    margin-bottom: 32px;
  }
  .introduce{
    font-size: 20px;
    color: #333333;
    line-height: 48px;
  }
  .text{
    font-size: 20px;
    color: #333333;
    line-height: 48px;
    text-indent: 2em;
  }
  
  .relation-graph-container {
    width: 100%;
    height: 600px;
    background: #f9f9f9;
    border-radius: 8px;
    padding: 20px;
    overflow: hidden;
  }
}


</style>